export default __webpack_public_path__ + "static/media/home-yoga-meditation-facility-img03.8f185170.jpg";